import { paths, routes } from 'pages/season/routes';
import api from 'resources/season/api';
import lazyWithRetry from 'services/lazyWithRetry';
import selectors from 'store/season/selectors';
import { actions } from 'store/season/slice';
import { SeasonApiItem } from 'typings/api';
import { Resource } from 'typings/shared';

const resource: Resource<SeasonApiItem, typeof paths, typeof api, typeof actions, typeof selectors, typeof routes> = {
    name: 'season',
    translationKey: 'season',
    api,
    selectors,
    paths,
    routes,
    actions,
    component: lazyWithRetry(() => import('pages/season')),
};

export default resource;
